import { useCreateTechnique } from '../../hooks/useTechniques';

import { TechniqueForm } from './TechniqueForm';

import { PageHeader } from '@/components/common/PageHeader';
import { AppShell } from '@/components/layout/AppShell';
import { TopBar } from '@/components/layout/TopBar';
import { useNavigate } from '@/lib/router';

export function NewTechniquePage() {
  const navigate = useNavigate();
  const createTechnique = useCreateTechnique();

  return (
    <AppShell>
      <TopBar title="Nouvelle technique" />
      <div className="mx-auto max-w-4xl p-4 md:p-6">
        <PageHeader
          title="Créer une technique"
          subtitle="Ajouter un nouveau geste technique au catalogue"
        />
        <TechniqueForm
          mode="create"
          isLoading={createTechnique.isPending}
          onCancel={() => void navigate({ to: '/techniques' })}
          onSubmit={async (data) => {
            await createTechnique.mutateAsync(
              data as Parameters<typeof createTechnique.mutateAsync>[0],
            );
            await navigate({ to: '/techniques' });
          }}
        />
      </div>
    </AppShell>
  );
}
